import usePortalModal from 'hooks/usePortalModal';
import { isFunction } from 'lodash';
import CheckCameraToTakePhotoEnableAlertPopup from './popup';

const CheckCameraToTakePhotoEnableAlertModal = ({
  isShow,
  modalOptions,
  actionClose,
}) => {
  const { closePortalModalName } = usePortalModal();

  const { zIndexBackdropOverlap, zIndexModal } = modalOptions || {};

  const handleOnClose = () => {
    if (isFunction(actionClose)) {
      actionClose();
      return;
    }
    closePortalModalName();
  };

  return (
    <CheckCameraToTakePhotoEnableAlertPopup
      isOpen={isShow}
      onClose={handleOnClose}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={zIndexBackdropOverlap || 1068}
      zIndexModal={zIndexModal || 1069}
    />
  );
};

export default CheckCameraToTakePhotoEnableAlertModal;
